<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import store from '../../store';

export default Vue.extend({
    props: {
        page: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState({
            instruction: state => state.instruction
        })
    },
    created() {
        store.dispatch('instruction/getDismissStatus', this.page);
    },
    methods: {
        ...mapActions({
            dismissInstruction: 'instruction/dismissInstruction'
        })
    }
});
</script>
<template>
    <div v-if="!instruction[page].dismiss" class="instruction">
        <div class="instruction__content">
            <div class="instruction__heading">
                <div class="instruction__header">
                    <span class="instruction__header-icon"><i class="fa fa-book-open"/></span>
                    <span>{{ $t( instruction[page].header ) }}</span>
                </div>
            </div>
            <div class="instruction__body" v-html="$t( instruction[page].body )"/>
            <div class="instruction__dismiss">
                <button class="instruction__dismiss-btn" @click="dismissInstruction(page)">
                    {{ $t( 'instruction.dismiss' ) }}
                </button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/Instruction/Instruction.vue